var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.49646C2.47141 5.49646 3.66667 4 3.66667 4C3.66667 4 4.92996 5.39632 6.14963 5.49646C7.48962 5.60649 9 4 9 4C9 4 10.4449 5.46961 11.6667 5.49646C12.9181 5.52397 14.3333 4 14.3333 4C14.3333 4 15.8148 5.49646 17 5.49646",
    stroke: "#D7D7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.49646C2.47141 9.49646 3.66667 8 3.66667 8C3.66667 8 4.92996 9.39632 6.14963 9.49646C7.48962 9.60649 9 8 9 8C9 8 10.4449 9.46961 11.6667 9.49646C12.9181 9.52397 14.3333 8 14.3333 8C14.3333 8 15.8148 9.49646 17 9.49646",
    stroke: "#D7D7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.4965C2.47141 13.4965 3.66667 12 3.66667 12C3.66667 12 4.92996 13.3963 6.14963 13.4965C7.48962 13.6065 9 12 9 12C9 12 10.4449 13.4696 11.6667 13.4965C12.9181 13.524 14.3333 12 14.3333 12C14.3333 12 15.8148 13.4965 17 13.4965",
    stroke: "#D7D7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlood);
export default __webpack_public_path__ + "static/media/flood.822093902e9d29e552bcbfe292f068b0.svg";
export { ForwardRef as ReactComponent };